module.exports = __webpack_public_path__ + "72e3871e8a597c3e2e951fc6c5831e62.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/drum.png
// module id = 1833
// module chunks = 0